import * as styled from './styles';

type Props = {
  message?: string;
  /** Centers vertically + horizontally in the viewport. Use when this stands in for a whole page. */
  fullPage?: boolean;
};

export const PageLoader = ({ message, fullPage }: Props) => (
  <styled.Container $fullPage={fullPage} role="status" aria-live="polite">
    <styled.Spinner aria-hidden="true" />
    {message ? <styled.Message>{message}</styled.Message> : null}
  </styled.Container>
);
